module.exports = __webpack_public_path__ + "static/media/transistor-voltage_reg.921c26f9.jpg";